export default __webpack_public_path__ + "static/media/SourceHanSansCN-ExtraLight.ad664c25.ttf";